import * as React from 'react';
import { Switch } from '@cian/ui-kit';
import { ISwitchComponentProps } from '../../utils/types';

export const SwitchComponent: React.FC<ISwitchComponentProps> = props => {
  const { isChecked, onChange } = props;

  return (
    <div>
      <Switch checked={isChecked} onChange={onChange} />
    </div>
  );
};
